import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { userSchema } from "../../Validations/User";
import { useFormik } from "formik";
import { Context } from "../../Context/Context";
import ReactGA from "react-ga4";

import { ADMIN, CLIENT, FIRM, PROFESSIONAL, TOKEN, getGAPageViewsApi, getUserIdByEmailApi, isUserVerifiedApi, raiseNotificationApi, sendSigninConfirmCodeApi, signinApi } from "../../Constants";
import React from "react";

import {Amplify} from 'aws-amplify';
import {signIn, signOut, updateMFAPreference} from 'aws-amplify/auth'

import awsConfig from "aws_config";
import HostedGoogleSignin from "./HostedGoogleSignin";
import QCRLogoMark from "Components/Icons/QCRLogoMark";
import EyeIcon from "Components/Icons/EyeIcon";
import FieldError from "Components/Element/FieldError";
import FormErrorBanner from "Components/Element/FormErrorBanner";
import { getUserLocation, getUserLocationFromIP, getFriendlyAuthErrorMessage } from "Utils";

Amplify.configure(awsConfig);



const Signin = ({expiryDate, setExpiryDate}) => {
    const {role} = useParams();
    const [locationDet, setLocationDet] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const {makeApiCallFunc, userDetails, setShowLoading} = useContext(Context);
    const [isClient, setIsClient] = useState(null);
    const [apiError, setApiError] = useState("");
    const [isCallMade, setIsCallMade] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";
    const [isUserVerified, setIsUserVerified] = useState(false);
    useEffect(() => {
        setIsClient(role ? (role === CLIENT ? true : false) : true)

    },[role])
    useEffect(() => {
        const getUserLocationSet = async () => {
            const location = await getUserLocation();
            if(location && location?.code === 1)
            {
                const locationFromIp = await getUserLocationFromIP();
                console.log("locationFromIp", locationFromIp);
                setLocationDet(locationFromIp);
            }
            else
            {
             console.log("location", location);
            setLocationDet(location);
            }
        }
       getUserLocationSet();
    },[])
    const handleFocus = (e) =>
    {
      setApiError("");
    }

    const submitSuccessCallback = (data) =>
    {
        ReactGA.set({ userId: data?.user?._id });
        ReactGA.set({ userIdentification: data?.user?._id });
        console.log("data", data);

        if(data?.user?.role === PROFESSIONAL)
        {
                if((data?.user?.verified && !data?.user?.isUserAssistant) || (data?.user?.isUserAssistant && data?.user?.profilePic)) //verified attorney and completed assistant
                {
                    if(data?.notificationCount > 0)
                    {
                        navigate("/attorney/notification");
                    }
                    else
                    {
                        navigate("/attorney/casesFeed/availableCases");
                    }
                }
                else //unverified attorney or incomplete assistatnt
                {
                    if(data?.approvalList && !data?.user?.isUserAssistant) //pending verification for attorney
                    {
                        navigate("/attorney/profile");
                    }
                    else if((!data?.approvalList && !data?.user?.isUserAssistant) || (data?.user?.isUserAssistant && !data?.user?.profilePic) ) //unverified attorney and incomeplete assistant and unverified law firm
                    {
                        navigate("/attorney/profileCompletion");
                    }
                }
                console.log("details", data?.user?.verified, data?.user?.role);
            //commenting MFA code - 15-10-2024
            // makeApiCallFunc(
            //     sendSigninConfirmCodeApi,
            //     {email: data?.user?.email},
            //     ({data}) => {
            //         if(data.isCodeSent)
            //         {
            //             setExpiryDate(data?.expiryDate);
            //             navigate("/mfaAuth");
            //         }
            //         else
            //         {
            //             if(data.message === "hasAccess")
            //             {
            //                 if(!data?.user?.verified && data?.user?.legalType === null)
            //                 {
            //                     navigate("/profile");
            //                 }
            //                 else
            //                 {
            //                     navigate("/casesFeed");
            //                 }
            //             }
            //             else
            //             {
            //                 console.log("Could not send you verification code. Please try again later");
            //                 //either signout the user or try to send code again internally.
            //                 //  signoutUser();
            //                 navigate("/");
            //             }
            //         }
            //     },
            //     (error) => {
            //         setApiError(error);
            //     }
            // )

        }

        if(data?.user?.role === ADMIN && !data.user.isAdminAssistant)
        {
            navigate("/admin/outreach");
        }
        else if(data?.user?.role === ADMIN && data.user.isAdminAssistant)
        {
            navigate("/admin/approve");
        }
        else if(data?.user?.role === CLIENT)
        {
            // came from a case link while signed out (e.g. the "insights ready" email): go back to that case
            let returnTo = null;
            try { returnTo = sessionStorage.getItem("qcr.returnTo"); sessionStorage.removeItem("qcr.returnTo"); } catch (e) { /* ignore */ }
            if (returnTo && returnTo.startsWith("/client/caseDetails/"))
            {
                navigate(returnTo);
            }
            else if(data?.notificationCount > 0)
                    {
                        navigate("/client/notification");
                    }
                    else
                    {
                        navigate("/client/cases");
                    }
        }
        else if(data?.user?.role === FIRM)
        {
            if(!data?.user?.verified)
            {
                // already sent for review -> profile page shows the status;
                // otherwise they still need to complete the firm profile
                navigate(data?.approvalList ? "/attorney/casesFeed/availableCases" : "/attorney/profileCompletion");
            }
            else
            {
                navigate("/attorney/casesFeed/availableCases"); //navigate to dashboard for verified law firm
            }
        }
    }
    const signoutUser = async () => {
        try {
            await signOut();
        } catch (error) {
            console.log("error signing out", error);
        }
    }
    const onSubmit = async (values, actions) =>
    {

            try {
                setShowLoading(true);
                const userDet =  await signIn({
                    username: values.email,
                    password: values.password,
                });
                if(!userDet?.isSignedIn && userDet?.nextStep?.signInStep === "CONFIRM_SIGN_UP")
                {
                    // Same loading-gauge bug as the wrong-password case: this path leaves the
                    // try block without ever turning the gauge back off.
                    setShowLoading(false);
                    navigate("/confirm");
                }
                else if(!userDet?.isSignedIn && userDet?.nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED")
                {
                    setShowLoading(false);
                    navigate("/resetpassword");
                }
                else if(userDet)
                {
                    console.log(userDet?.nextStep?.signInStep);
                    makeApiCallFunc(
                        signinApi,
                        {email: values.email,
                        "locationDet": locationDet,
                        },
                        ({data}) => {
                            submitSuccessCallback(data);
                            setShowLoading(false);
                        },
                        (error) => {
                            setApiError(getFriendlyAuthErrorMessage(error));
                            setShowLoading(false);
                        },
                        // null,
                        // false,
                        // true
                    )
                }
            } catch (error) {
                console.log('error signing in', {error});
                if(error.name === "UserAlreadyAuthenticatedException")
                {
                    setApiError(
                        <>
                            {error.message}{" "}
                            <div className="underline cursor-pointer" onClick={async () => {await signOut();
                            localStorage.clear();
                             navigate("/");}}>
                            Click here to Sign out and try again
                            </div>
                        </>
                    );
                    // await signOut(); - why was this included ? - user is signed out and signed in
                }
                else
                {
                    setApiError(getFriendlyAuthErrorMessage(error));
                }
                // Bug fix: this catch handles errors thrown directly by the Cognito signIn()
                // call (e.g. wrong password). setShowLoading(true) above was never matched by a
                // setShowLoading(false) on this path, so the loading gauge stayed on screen even
                // though the error message had already rendered.
                setShowLoading(false);
            }

    }
    const {values, errors, touched, handleBlur, handleChange, setFieldValue, handleSubmit, isSubmitting} = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema : userSchema,
        onSubmit,
    })


return (
    <div className="min-h-screen w-full bg-cream font-plexsans flex flex-col items-center">
        <div className="w-full bg-ivory border-b border-navy/10 flex justify-center py-4 lg:py-5">
            <Link to="/" className="flex items-center gap-2">
                <QCRLogoMark/>
                <span className="flex items-start gap-1">
                    <span className="font-plexsans font-semibold text-[12px] tracking-wide uppercase text-navy">Quick Case Review</span>
                    <span className="font-plexmono font-medium text-[7px] tracking-widest uppercase text-tan mt-px">Beta</span>
                </span>
            </Link>
        </div>

        <div className="w-full flex-1 flex items-start lg:items-center justify-center px-4 py-10 lg:py-14">
        <div className="w-full max-w-[460px]">
        <div className="bg-ivory border border-navy/[0.14] rounded p-7 lg:p-8">

            <h1 className="font-spectral font-normal text-navy text-[22px] lg:text-[23px] text-center leading-[1.3] m-0 mb-7">
                Welcome back.<br/>Sign in to your account
            </h1>

            <FormErrorBanner>{apiError}</FormErrorBanner>

            <form onSubmit={handleSubmit} className="font-plexsans w-full flex flex-col">
                <div className="flex flex-col gap-3">
                    <div>
                        <input
                            type="text"
                            name="email"
                            placeholder="Enter your email address"
                            value={values.email}
                            onChange={(e) => setFieldValue("email", e.target.value.toLowerCase())}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                            className={"w-full font-plexsans text-[14px] text-navy px-3.5 py-3.5 bg-cream border rounded-sm outline-none placeholder:text-navy/40" + (errors.email && touched.email ? " border-red-500" : " border-navy/[0.18]")}
                        />
                        {errors.email && touched.email && <FieldError>{errors.email}</FieldError>}
                    </div>
                    <div>
                        <div className="relative">
                            <input
                                type={!showPassword ? "password" : "text"}
                                name="password"
                                id="password"
                                placeholder="Password"
                                onFocus={() => setApiError("")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                className={"w-full font-plexsans text-[14px] text-navy px-3.5 py-3.5 pr-11 bg-cream border rounded-sm outline-none placeholder:text-navy/40" + (errors.password && touched.password ? " border-red-500" : " border-navy/[0.18]")}
                            />
                            <button
                                type="button"
                                aria-label={showPassword ? "Hide password" : "Show password"}
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute inset-y-0 right-0 flex items-center mr-3.5 text-navy/50 bg-transparent border-none p-0 cursor-pointer"
                            >
                                <EyeIcon open={showPassword}/>
                            </button>
                        </div>
                        {errors.password && touched.password && <FieldError>{errors.password}</FieldError>}
                    </div>
                </div>

                <button
                    type="submit"
                    disabled={isSubmitting}
                    className={"w-full font-plexsans font-medium text-[14px] text-ivory bg-tan hover:bg-tanDark rounded-sm py-3.5 mt-5 transition-colors cursor-pointer" + (isSubmitting ? " opacity-50 cursor-not-allowed" : "")}
                >
                    Sign in
                </button>
            </form>

            <div className="flex items-center gap-3 my-4">
                <div className="flex-1 h-px bg-navy/[0.16]" />
                <span className="font-plexsans text-[12px] text-navy/50">Or</span>
                <div className="flex-1 h-px bg-navy/[0.16]" />
            </div>
            <HostedGoogleSignin/>

            <div className="flex justify-between mt-6 gap-3 font-plexsans text-[12.5px]">
                <Link to={"/signup/"} className="text-navy underline underline-offset-2">Don't have an account?</Link>
                <Link to="/forgotpassword" className="text-navy underline underline-offset-2">Forgot password</Link>
            </div>
        </div>
        </div>
        </div>
    </div>
)
}

export default Signin;
